import { ISaSmsTenantDetail } from '@interfaces/sa-sms';
import { Button, Card, Col, Row, Statistic } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SmsAutoRechargeAdmin } from './sms-auto-recharge-admin';
import { SmsCreditAdjustModal } from './sms-credit-adjust-modal';
import { SmsLedgerTable } from './sms-ledger-table';

type Props = { detail: ISaSmsTenantDetail; canEdit: boolean; onChanged: () => void };

/** Credits tab: balance (included / purchased), admin adjust, ledger, auto-recharge override. */
export const SmsCreditsTab: React.FC<Props> = ({ detail, canEdit, onChanged }) => {
    const { t, i18n } = useTranslation(['sa-sms']);
    const [adjusting, setAdjusting] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const b = detail.balance;
    const num = (n?: number) => (n === undefined ? '-' : n.toLocaleString(i18n.language));
    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Card
                    title={t('credits.balance')}
                    extra={
                        canEdit && (
                            <Button onClick={() => setAdjusting(true)}>
                                {t('credits.adjust')}
                            </Button>
                        )
                    }
                >
                    <Row gutter={16}>
                        <Col xs={24} md={6}>
                            <Statistic title={t('credits.available')} value={num(b?.available)} />
                        </Col>
                        <Col xs={12} md={6}>
                            <Statistic title={t('credits.included')} value={num(b?.included)} />
                        </Col>
                        <Col xs={12} md={6}>
                            <Statistic title={t('credits.purchased')} value={num(b?.purchased)} />
                        </Col>
                        <Col xs={24} md={6}>
                            <Statistic
                                title={t('credits.resets')}
                                value={
                                    b?.includedResetsAt
                                        ? new Date(b.includedResetsAt).toLocaleDateString(
                                              i18n.language,
                                          )
                                        : '-'
                                }
                            />
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col xs={24} lg={14}>
                <SmsLedgerTable tenantId={detail.tenantId} refreshKey={refreshKey} />
            </Col>
            <Col xs={24} lg={10}>
                <SmsAutoRechargeAdmin
                    tenantId={detail.tenantId}
                    settings={detail.autoRecharge}
                    canEdit={canEdit}
                    onChanged={onChanged}
                />
            </Col>
            <SmsCreditAdjustModal
                tenantId={detail.tenantId}
                open={adjusting}
                onClose={() => setAdjusting(false)}
                onDone={() => {
                    setRefreshKey((k) => k + 1);
                    onChanged();
                }}
            />
        </Row>
    );
};
